import React from 'react';
import './Careers.css';
import TeamsSection from './TeamsSection';

const Careers = () => {
  return (
    <div>
    <div className="careers-container">
      <h1 className="careers-heading">Careers at Tesseract Flex Fuel</h1>
    </div>
    <TeamsSection />
    </div>
  );
};

export default Careers;
